import { render, staticRenderFns } from "./SelectInputGroup.vue?vue&type=template&id=61304dc4&"
import script from "./SelectInputGroup.vue?vue&type=script&lang=js&"
export * from "./SelectInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports